<template>
  <div class="customer-tools">
    <div class="header">
      <div class="title">Customer Tools</div>
      <div class="description">Designed for CHeKT Service End Users</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          You are currently a member of {{mySites.length}} site(s).
        </div>
      </div>
    </div>
    <div class="apps">
      <!-- enduser portal -->
      <!-- <div class="app">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'enduser'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Enduser Web App</div>
        <div class="description">Enduser Web App for customers to view live video of the cameras installed at the site.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL($env.appWebUrl)" ontouchstart=""
          class="action-btn">{{$env.appWebUrl}}</div>
        </div>
      </div> -->
      <div class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'enduserMobile'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Enduser Mobile App</div>
        <div class="description">Enduser Mobile App for customers to view live video of the cameras installed at the site.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL('https://apps.apple.com/us/app/id1508918518 ')" ontouchstart=""
          class="action-btn">iOS</div>
          &nbsp;&nbsp;
          <div
          v-on:click="goToURL('https://play.google.com/store/apps/details?id=com.chekt.app.v3')" ontouchstart=""
          class="action-btn">Android</div>
        </div>
      </div>
      <!-- share -->
      <!-- Disabled for now, will be displayed once tutorial is completed. -->
      <!-- <div class="app">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'share'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Share Web App</div>
        <div class="description">It is for event verification. And it is to share event to police officers.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL($env.shareWebUrl)" ontouchstart=""
          class="action-btn">{{$env.shareWebUrl}}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import CompAppIcon from '@/components/CompAppIcon'
export default {
  name: 'customer-tools',
  components: {
    CompAppIcon
  },
  computed: {
    mySites: function () {
      return this.$store.getters.mySites
    }
  },
  data: function () {
    return {
      appIconWidth: 340
    }
  },
  methods: {
    goToURL: function (url) {
      this.$tool.openNewTab(url)
    }
  }
}
</script>

<style scoped>

.customer-tools {
  /* size */
  width: 100%;
  height: 100%;
}

.customer-tools .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* alignment */
  text-align: left;
}
.customer-tools .header .title {
  /* common */
  font-size: 3em;
  /* text */
  font-weight: bold;
}
.customer-tools .header .description {
  /* common */
  font-size: 1.5em;
}

.customer-tools .apps {
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.customer-tools .app {
  /* common */
  font-size: 16px;
  /* size */
  max-width: 340px;
  width: 100%;
  /* position */
  margin-right: 2em;
  /* alignment */
  text-align: left;
}
.customer-tools .app .title {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 16px;
  /* text */
  font-weight: bold;
  line-height: 2rem;
  /* position */
  margin-top: 1.5rem;
  margin-bottom: 10px;
}
.customer-tools .app .description {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 14px;
  color: var(--gray-medium);
  /* position */
  margin-bottom: 10px;
}
.customer-tools .app .icon-container {
  /* common */
  overflow: hidden;
  border-radius: 4px;
}

.customer-tools .app .action-btns {
  /* common */
  font-size: 14px;
  /* size */
  padding-right: 0.5em;
  /* position */
  margin-bottom: 10px;
  /* alignment */
  display: flex;
  flex-direction: row;
}
.customer-tools .app .action-btns .action-btn {
  /* common */
  color: var(--gray-low);
  /* mouse */
  cursor: pointer;
}
.customer-tools .app .action-btns .action-btn:hover {
  /* common */
  color: var(--primary);
}




.customer-tools .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid #dedede;
  /* alignment */
  text-align: left;
}

.customer-tools .body .content {
  /* common */
  color: var(--gray-high);
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: 100%;
  /* min-height: 4em; */
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}

.customer-tools .body .content .info-container:first-child {
  margin-top: 0;
}
.customer-tools .body .content .info-container {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  margin: 1em 0;
  /* alignment */
  display: table;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/CustomerTools.vue